import { Component, Input } from '@angular/core';
import { FuseNavigationItem } from '../../../../core/models/interface/navigation.types';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FuseVerticalNavigationBasicItem } from '../fuse-vertical-navigation-basic-item/basic.component';
import { FuseVerticalNavigationCollapsableItem } from '../fuse-vertical-navigation-collapsable-item/collapsable.component';

@Component({
    selector: 'fuse-vertical-navigation-group-item',
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule,

        FuseVerticalNavigationBasicItem,
        FuseVerticalNavigationCollapsableItem
    ],
    templateUrl: './group.component.html',
})
export class FuseVerticalNavigationGroupItem {
    @Input() autoCollapse!: boolean;
    @Input() item!: FuseNavigationItem;
    @Input() name!: string;

    isCollapsed: boolean = true;

    onCollapse(_isCollapsed: boolean) {
        this.isCollapsed = _isCollapsed;

        //console.log("collapse de collpase component", this.isCollapsed);
        
    }
}
